import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { CodesSimusCollectionDTO, CodesSimusCollectionDTOSchema, Simulation, TypeProduit } from "@mra/hlp9002";
import { map, Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { VALIDATION_SCHEMA_CONTEXT } from "../api/http-format-interceptor.service";

@Injectable({
    providedIn: "root"
})
export class SimulationService {
    private readonly http = inject(HttpClient);
    private readonly context: HttpContext = new HttpContext().set(VALIDATION_SCHEMA_CONTEXT, CodesSimusCollectionDTOSchema);

    /**
     * récupère une liste de codes de simulation qui ont le type de produit indiqué
     * @param typeProduit - type de produit
     * @returns liste de codes de simulation
     */
    getCodesSimuByTypeProduit(typeProduit: TypeProduit): Observable<string[]> {
        return this.http
            .get<CodesSimusCollectionDTO>(environment.urlsMs.MS1401, {
                params: {
                    typeProduit
                }
            })
            .pipe(map((res) => res.simulations));
    }

    /**
     * récupère une simulation par son code
     * @param codeSimulation - code de la simulation
     * @returns simulation
     */
    getSimulationByCode(codeSimulation: string): Observable<Simulation> {
        return this.http.get<Simulation>(environment.urlsMs.MS1401, {
            context: this.context,
            params: {
                codeSimulation
            }
        });
    }
}
